export const LOGIC_OPERATORS = {
  AND: 'and',
  OR: 'or'
}

export const MATCH_OPERATORS = {
  WITH: 'with',
  WITHOUT: 'without'
}

export const REGEX_INDICATORS = {
  AND_SEPARATOR: ')(',
  OR_SEPARATOR: '|',
  WITHOUT_INDICATOR: '?!',
  WITH_INDICATOR: '.*',
  AND_INDICATOR: '?=',
  WITH_TEXT_START_SEPARATOR: '.*',
  WITHOUT_TEXT_END_SEPARATOR: ').',
  EMPTY_WITHOUT_INDICATOR: '([\\s\\S]+)',
  EMPTY_WITH_INDICATOR: '(?:)'
}

export const REGEXES = {
  MATCH_EVERYTHING_WITH: /(.*)/gi,
  MATCH_EVERYTHING_WITHOUT: /[\s\S]+/gi,
  VALID_URL: /^(http(s):\/\/.)[-a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_\+.~#?&//=]*)$/,
  VALID_IMAGE_URL: /(http(s?):)([/|.|\w|\s|-])*\.(?:jpg|gif|png)/gi,
  VALID_YOUTUBE_URL: /^.*((youtu.be\/)|(v\/)|(\/u\/\w\/)|(embed\/)|(watch\?))\??v?=?([^#\&\?]*).*/gi,
  YOUTUBE_ID_EXTRACTION: /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|&v=)([^#&?]*).*/,
  SPACE_BEFORE_WORD: /\S+$/,
  SPACE_AFTER_WORD: /\s/,
  DIAL_CODE: /^[0-9+]+$/,
  EMAIL: /^[A-Za-z0-9._%+-]+@(?:[A-Za-z0-9-]+\.)+[A-Za-z]{2,63}$/,
  NUMBERS_AND_SPACES: /^[0-9\s]+$/,
  PHONE: /^(\+(?:\d+[ -]?){0,19}\d?)?$/
}

export const EMPTY_INPUT_REGEX_MANIFESTATIONS = [
  '^', '?', ')', '(', '.*'
]

export const CUSTOMERS_URL_LABEL = 'Customer\'s URL'
